
import React from 'react';
import { AlertTriangle, CheckCircle } from 'lucide-react';
import { 
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Attendee } from '@/types/attendee';

interface PaymentConfirmDialogProps {
  attendee: Attendee;
  isOpen: boolean;
  setIsOpen: (show: boolean) => void;
  pendingStatus: boolean | null;
  onConfirm: () => void;
  onCancel: () => void;
}

const PaymentConfirmDialog: React.FC<PaymentConfirmDialogProps> = ({
  attendee,
  isOpen,
  setIsOpen,
  pendingStatus,
  onConfirm,
  onCancel
}) => {
  return (
    <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
      <AlertDialogContent className={`border ${pendingStatus ? 'border-green-400' : 'border-red-400'}`}>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            {pendingStatus ? (
              <>
                <CheckCircle className="h-5 w-5 text-green-500" />
                Xác nhận thay đổi trạng thái thanh toán?
              </>
            ) : (
              <>
                <AlertTriangle className="h-5 w-5 text-amber-500" />
                Cảnh báo: Đánh dấu chưa thanh toán?
              </>
            )}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {pendingStatus 
              ? `Bạn có chắc muốn đánh dấu ${attendee.name} đã thanh toán không?`
              : `Bạn có chắc muốn đánh dấu ${attendee.name} CHƯA thanh toán không? Điều này sẽ ngăn họ check-in.`
            }
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>Hủy bỏ</AlertDialogCancel>
          <AlertDialogAction 
            onClick={onConfirm}
            className={pendingStatus ? "bg-green-500 hover:bg-green-600" : "bg-red-500 hover:bg-red-600"}
          >
            {pendingStatus ? "Xác nhận đã thanh toán" : "Xác nhận chưa thanh toán"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default PaymentConfirmDialog;
